export default {
  gift_card_removed: 'Geschenkkarte entfernt',
  invalid_gift_card: 'Geschenkkarte ist ungültig',
  gift_card_applied: 'Geschenkkarte angewendet',
};
